/** Hosted UI version, deliberately independent of the installed native binary. */
export const CLIENT_LINK_RELEASE = "0.2.9";

export interface DesktopRuntime { updater?: boolean; version?: string; platform?: string }
export const desktopRuntime = (): DesktopRuntime | undefined =>
  (globalThis as { __LINK_DESKTOP__?: DesktopRuntime }).__LINK_DESKTOP__;

export function desktopAppLabel(platform?: string): string {
  return platform === "windows" ? "Windows app" : platform === "macos" ? "macOS app" : "Desktop app";
}
